import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import { motion } from "framer-motion";
import { BiCart, BiDetail } from "react-icons/bi";
import { AiOutlineEye } from "react-icons/ai";
import TransitionsModal from "./Modal";

const Item = ({ details, categ_id }) => {
  const { sidebarCartDetail } = useStateContext();
  const navigate = useNavigate();
  function trauncate(string, n) {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  }

  const wholePrice = details.price;
  const variants = {
    hidden: { opacity: 0, y: 7 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.7,

        ease: "easeOut",
        duration: 0.4,
      },
    },
  };
  const variant2 = {
    hidden: { opacity: 0, x: 10 },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        ease: "easeOut",
        
      },
    },
  };






  

  return (
    <motion.div
      variants={variants}
      initial={"hidden"}
      whileInView={"show"}
      viewport={{ once: true }}
    >
      <Container widthComponent={sidebarCartDetail}>
        <ImageWrapper>
          <img
            src={details.image}
            alt=""
            onClick={() =>
              navigate(`/itemdetails/${details.prod_id}/${categ_id}`)
            }
          />
        </ImageWrapper>
        <TextWrapper>
          <p style={{ fontSize: "12px" }}>{trauncate(details.descr, 110)}</p>
          <p style={{ marginTop: "0px" }}>
            <sup style={{ fontSize: "14px" }}>$</sup>
            <b style={{ fontSize: "27px" }}>
              {wholePrice.toString().split(".")[0]}
            </b>
            <sup style={{ fontSize: "14px" }}>
              {wholePrice.toString().split(".")[1]}
            </sup>{" "}
          </p>
          <BiCart size={20} />
        </TextWrapper>
        <motion.div variants={variant2} initial={"hidden"} whileInView={"show"}>
          <Controlers>
            <TransitionsModal product={details} />
            <BiDetail
              size={20}
              onClick={() =>
                navigate(`/itemdetails/${details.prod_id}/${categ_id}`)
              }
            />
          </Controlers>
        </motion.div>
      </Container>
    </motion.div>
  );
};

export default Item;

const Controlers = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  flex-direction: column;
  justify-content: space-between;
  display: none;

  svg {
    padding: 4px;
    border-radius: 4px;
    margin-bottom: 7px;
    border: 1px solid #eb6fd9;
    color: #71596d;
  }
`;

const Container = styled.div`
  height: ${(props) => (props.widthComponent ? "360px" : "380px")};
  width: ${(props) => (props.widthComponent ? "290px" : "320px")};
  background-color: #f2d9ec;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid pink;
  border-radius: 10px;
  transition: all 0.5s ease-in-out;
  position: relative;
  &:hover ${Controlers} {
    display: flex;
  }
  :hover {
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
    transform: scale(1.01);
  }

  cursor: pointer;
  @media (max-width: 470px) {
    height: ${(props) => (props.widthComponent ? "300px" : "370px")};
    width: ${(props) => (props.widthComponent ? "230px" : "270px")};
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 70%;
  background: #ffffff;

  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    object-fit: contain;
    width: 100%;
    height: 70%;
  }
  @media (max-width: 470px) {
    width: 100%;
    height: 60%;
  }
`;

const TextWrapper = styled.div`
  width: 90%;
  height: 30%;
  position: relative;
  svg {
    position: absolute;
    bottom: 10px;
    right: 0px;
    padding: 3px;
    border-radius: 4px;
    border: 1px solid #f0a1eb;
    background-color: #ffff;
  }
  @media (max-width: 470px) {
    width: 94%;
    height: 40%;
  }
  background: #f2d9ec;
  display: flex;
  flex-direction: column;
  b {
    @media (max-width: 470px) {
      font-size: 14px !important;
    }
  }
`;
